import { Component, OnInit, OnDestroy } from '@angular/core';
import { EquipmentType } from '../../../interfaces/equipment/equipment-type';
import { EquipmentService } from '../../../services/equipment/equipment.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NotificationService } from '../../../services/notification.service';
import { EventNotification } from '../../../interfaces/event-notification';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { EquipmentListComponent } from '../equipment-list/equipment-list.component';

@Component({
  selector: 'app-equipment-overview',
  standalone: true,
  imports: [CommonModule, RouterModule, EquipmentListComponent],
  templateUrl: './equipment-overview.component.html',
  styleUrls: ['./equipment-overview.component.scss']
})
export class EquipmentOverviewComponent implements OnInit, OnDestroy {
  types: EquipmentType[] = [];
  selectedType!: EquipmentType;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private equipmentService: EquipmentService,
    public router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    // Load equipment types
    this.subscriptions.add(
      this.equipmentService.getTypes()
        .subscribe((t: EquipmentType[]) => {
          this.types = t;
        })
    );

    // Subscribe to notifications
    this.subscriptions.add(
      this.notificationService.notifications
        .subscribe((n: EventNotification<EquipmentType[], any>) => {
          if (n.type === 'equipmentCountUpdated') {
            for (const t of this.types) {
              const item = n.data.find(x => x.id === t.id);
              if (item) Object.assign(t, item); 
            }
          }
        })
      );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe(); // prevent memory leaks
  }

  selectType(equipmentTypeId: number | null): void {
    this.router.navigate(['/equipment', equipmentTypeId]);
  }

  selectAll(): void {
    this.router.navigate(['/equipment']);
  }

  isRouteActive(path: string, exact: boolean = false): boolean {
    const tree = this.router.createUrlTree([path]);
    return this.router.isActive(tree, { paths: exact ? 'exact' : 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' });
  }
}

